if (!customElements.get('ls-heulage-gallery')) {
  class LsHeulageGallery extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.tabs = Array.from(this.querySelectorAll('[data-gallery-target]'));
      this.panels = Array.from(this.querySelectorAll('[data-gallery-panel]'));
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-gallery-target]');
        if (tab && this.contains(tab)) this.select(tab.dataset.galleryTarget, tab, true);
      });
      this.addEventListener('keydown', (event) => {
        const tab = event.target.closest('[data-gallery-target]');
        if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const current = this.tabs.indexOf(tab);
        let next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1);
        next = (next + this.tabs.length) % this.tabs.length;
        this.tabs[next].focus();
        this.select(this.tabs[next].dataset.galleryTarget, this.tabs[next], false);
      });
    }

    select(target, selectedTab, navigateToVariant = false) {
      this.panels.forEach((panel) => {
        const active = panel.dataset.galleryPanel === target;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      this.tabs.forEach((tab) => {
        const active = tab === selectedTab;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (navigateToVariant && selectedTab?.dataset.galleryVariantUrl && selectedTab.dataset.galleryVariantId !== this.dataset.currentVariantId) {
        this.classList.add('is-loading');
        window.location.assign(selectedTab.dataset.galleryVariantUrl);
      }
    }
  }
  customElements.define('ls-heulage-gallery', LsHeulageGallery);
}
